//Nothing in that file reimplements PaginatedTable, Pagination, or server paging. Those were already there. The new module associateFeePagination.js only holds localStorage read/write for the Associate Fee page size
const STORAGE_KEY = "associateFee_pageSize";
const ALLOWED = [10, 25, 50, 100, 200];

export function getStoredAssociateFeePageSize() {
  try {
    const n = Number(localStorage.getItem(STORAGE_KEY));
    return ALLOWED.includes(n) ? n : 10;
  } catch {
    return 10;
  }
}

export function setStoredAssociateFeePageSize(n) {
  if (!ALLOWED.includes(n)) return;
  try {
    localStorage.setItem(STORAGE_KEY, String(n));
  } catch {
    /* ignore quota / private mode */
  }
}
